import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const reportProblemSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getIssueTypesFilter: builder.query({
            query: () => {
                return {
                    url: constants.ISSUE_TYPES
                };
            },
        }),
        saveProblemReport: builder.mutation({
            query: (arg: any) => ({
                url: constants.REPORT_PROBLEM,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Post'],
        }),
    }),
});

export const {
    useGetIssueTypesFilterQuery,
    useSaveProblemReportMutation
} = reportProblemSlice;
